/*
 * Copyright (C) 2021 IHS Markit.
 * All Rights Reserved
 *
 * NOTICE: All information contained herein is, and remains
 * the property of IHS Markit and its suppliers,
 * if any. The intellectual and technical concepts contained
 * herein are proprietary to IHS Markit and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from IHS Markit.
 */
import {DefaultUrlSerializer, UrlSerializer, UrlTree} from '@angular/router';
import {Injectable} from '@angular/core';
import {DataSharingService} from './iBoxx/services/data-sharing.service';

@Injectable()
export class CustomUrlSerializer implements UrlSerializer {

  constructor(private urlShare: DataSharingService) {
  }

  parse(url: any): UrlTree {
    const dus = new DefaultUrlSerializer();
    this.urlShare.indexURL.next(url.split('?')[1]);
    if (url.includes('=')) {
      const urlParts = url.split('=');
      let URL = urlParts[0] + '=';
      URL += urlParts[1].includes('+') ? encodeURIComponent(urlParts[1]) : urlParts[1];
      return dus.parse(URL);
    }else{
      return dus.parse(url);
    }
    // return dus.parse(unescape(URL));
  }

  serialize(tree: UrlTree): any {
    const dus = new DefaultUrlSerializer();
    return dus.serialize(tree);
  }

}
